import React from 'react';
import { string, func, bool } from 'prop-types';
import Wrapper from '../Wrapper';
import Row from '../Container/Row';
import Card from '../Card/Card';
import Icon from '../Icon';

const SectionHeader = ({ title, subtitle, isOpen, onClick }) => {
  return (
    <Wrapper onClick={onClick}>
      <Row flexDirection="row">
        <Row width="95%" flexDirection="column">
          <Card.TitleText className="title">{title}</Card.TitleText>
          <Card.SubtitleText className="sub-title" color="greyDark">
            {subtitle}
          </Card.SubtitleText>
        </Row>
        <Row width="5%" alignItems="center" justifyContent="center">
          {isOpen ? (
            <Icon icon="ExpandLessIcon" fontsize="normal" />
          ) : (
            <Icon icon="ExpandMoreIcon" fontsize="normal" />
          )}
        </Row>
      </Row>
    </Wrapper>
  );
};

SectionHeader.propTypes = {
  title: string,
  subtitle: string,
  isOpen: bool,
  onClick: func,
};

export default SectionHeader;
